'use strict';

import {reverseUrl} from 'utils/django';

import './style.css';
import modalDirective from '../../rest-modal';
import template from './template.html';


export default modalDirective({
	template: template,
	resolve: {
		userList: resolveUserList,
		phoneNumberList: resolvePhoneNumberList,
		statusNumber: resolveStatusNumber,
	},
	controller: controller,
	refreshIncident: true,
});


function controller($timeout, $scope) {
	'ngInject';

	$scope.customPhoneNumber = function() {
		// ui-mask has a lot of unaccessible code that handles marking that a
		// change occurred.  This hack seems to work to get around replicating that
		// code here.
		$timeout(function() {
			var input = document.getElementById('form-team-sequential-phone-number');
			angular.element(input).val('');
			input.focus();
			input.blur();
			input.focus();
		}, 0);
	}

	$scope.range = [];
	for (var i = 1; i <= Math.min($scope.$resolve.userList.length, 4); i++) {
		$scope.range.push(i);
	}
}


function resolveUserList($incident, $http, $context) {
	'ngInject';

	var url = '/entity-data/user_list_' + $context.listName;
	return $http.get(url).then(function(response) {
		return response.data.results[0].value;
	});
}


export function resolvePhoneNumberList($http, $incident, $context) {
	'ngInject';

	var url;
	if ($context.from) {
		return processData($context.from);
	} else if (url = $incident.phoneFromUrl) {
		return $http.get(url, {cache: false}).then(processData);
	} else if (url = $context.fromUrl) {
		return $http.get(url, {cache: false}).then(processData);
	} else {
		return [];
	}
}


export function resolveStatusNumber(phoneNumberList) {
	'ngInject';

	try {
		return phoneNumberList[0];
	} catch(e) {
		return '';
	}
}

function processData(response) {
	var data = response.data;
	if(!Array.isArray(data)) {
		data = [data];
	}
	return data;
}
